import { render, staticRenderFns } from "./IngredientItem.vue?vue&type=template&id=1b7c7a9a"
import script from "./IngredientItem.vue?vue&type=script&lang=js"
export * from "./IngredientItem.vue?vue&type=script&lang=js"
import style0 from "./IngredientItem.vue?vue&type=style&index=0&id=1b7c7a9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports